import { Injectable } from '@angular/core';
import { User } from '../model/types';
import { S3Factory } from '../../utils';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import 'rxjs/add/operator/map';
import { Subject } from 'rxjs';
import { SearchResult } from '../model/analysis-details.model';
import { environment } from '../../environments/environment';
import { AuthNewService } from './auth-new.service';
import { StorageService } from './storage.service';
import { DatePipe } from '@angular/common';
import { Body } from 'aws-sdk/clients/s3';
declare let TextDecoder: new (arg0: string) => { (): any; new(): any; decode: { (arg0: Body | undefined): any; new(): any; }; };

@Injectable({
  providedIn: 'root'
})
export class DownLoadService {

  private signedInUser?: User;
  private region: string;
  private signedUrlExpireSeconds = 60 * 5;
  dataLoaded = new Subject<SearchResult[]>();
  BUCKET: string = environment.bucket;
  graph_variable?: string;
  newFileName?: string;
  contentDisposition?: string;
  projectVersion=environment.version;


  constructor(private http: HttpClient,
    private authService: AuthNewService,
    private storageService: StorageService,
    private datePipe: DatePipe) {
    this.region = environment.defaultRegion || 'us-east-2';


  }

  setSignedInUser(user: User) {
    this.signedInUser = user;
  }

  // Upload status updates

  setRegion(region: string) {
    this.region = region;
  }

  listFiles() {
    return S3Factory.getS3(this.region).listObjectsV2({
      Bucket: this.BUCKET,
      Prefix: [this.signedInUser?.username, this.signedInUser?.userId].join('/')
    }).promise();
  }

  getUrl(key: string,replace_filename= true,analysisType?:string,fileExcelName?:string) {
    let filename: string;

  // Determine file extension
  const isPdf = key.toLowerCase().endsWith('.pdf');
  const isExcel = key.toLowerCase().endsWith('.xlsx') || key.toLowerCase().endsWith('.xls');
   if (analysisType === 'AP') {
    // For AP analysis type
    filename = isPdf
      ? `RedThread User Uploaded File(s)_${fileExcelName}.pdf`
      : 'RedThread_Analysis_Report.xlsx';
  } else {
    // For all other analysis types
    filename = isPdf
      ? `RedThread User Uploaded File(s)_${fileExcelName}_${this.projectVersion}.pdf`
      : `RedThread_Analysis_Report_${fileExcelName}_${this.projectVersion}.xlsx`;
  }

  this.contentDisposition =`attachment; filename="${filename}"`;


  return S3Factory.getS3(this.region).getSignedUrl('getObject', {
    Bucket: this.BUCKET,
    Key: key,
    ResponseContentDisposition: this.contentDisposition,
    Expires: this.signedUrlExpireSeconds
  });

  }

  async getS3Obj(key: string) {
    try {
      const params = {
        Bucket: this.BUCKET,
        Key: key
      };
      const data = await S3Factory.getS3(this.region).getObject(params).promise();
      const result = new TextDecoder('utf-8').decode(data.Body);
      return result;
    } catch (e:any) {
      throw new Error(`Could not retrieve file from S3: ${e.message}`);
    }
 /*   S3Factory.getS3(this.region).getObject({
      Bucket: this.BUCKET,
      Key: key
    }, function (err, data) {
      if (err) { console.log(err, err.stack); } else {
        const string = new TextDecoder('utf-8').decode(data.Body);


      }
    })
*/  }






}
